import service from "@/libs/service";

// TODO: Extraer mocks a archivo propio
const validationMock = async data => {
    if (data.discountCode === "ikigaicash") {
        return {
            data: {
                valid: true,
                discount: {
                    type: "cash",
                    amount: 20000,
                },
            }
        };
    } else if (data.discountCode === "ikigaipercentage") {
        return {
            data: {
                valid: true,
                discount: {
                    type: "percentage",
                    amount: 20,
                },
                
            }
        };
    } else {
        return {
            data: {
                valid: false,
                discount: {
                    type: "none",
                    amount: 0,
                },
            }
        };
    }
};

export const namespaced = true;

export const state = {
    completed: false,
    currency: "CLP",
    codeDiscount: "",
    invoice: undefined,
    method: "mercadopago",
    payment: undefined,
    selectedPack: undefined,
};

export const mutations = {
    SET_COMPLETED_PAYMENT(state, completedPayment) {
        state.completed = completedPayment;
    },
    SET_CURRENCY(state, currency) {
        state.currency = currency;
    },
    SET_DISCOUNT(state, codeDiscount) {
        state.codeDiscount = codeDiscount;
    },
    SET_METHOD(state, method) {
        state.method = method;
    },
    SET_PAYMENT_DATA(state, paymentData) {
        state.payment = paymentData;
    },
    SET_SELECTED_PACK(state, pack) {
        state.selectedPack = pack;
    },
    SET_EXTERNAL_REFERENCE(state, externalReference) {
        state.externalReference = externalReference;
    },
    SET_INVOICE(state, invoice) {
        state.invoice = invoice;
    },
};

export const actions = {
    async createPreference({ commit }, packData) {
        try {
            let success = packData.discountCode
                ? `${process.env.VUE_APP_ROOT_URL}/checkout/success?discount=${packData.discountCode}`
                : `${process.env.VUE_APP_ROOT_URL}/checkout/success`;

            const data = {
                ...packData,
                // SUMAR IVA AQUÍ?
                unitPrice: (packData.unitPrice * 1.19),
                externalId: packData.packCode, 
                backUrls: {
                    failure: `${process.env.VUE_APP_ROOT_URL}/checkout/failure`,
                    pending: `${process.env.VUE_APP_ROOT_URL}/checkout/pending`,
                    success,
                }
            };
            const preference = await service.request("/accounts/create/preference", data);
            commit("SET_EXTERNAL_REFERENCE", preference.external_reference);
            
            return preference; 
        } catch (error) {
            return error;
        }
    },
    async registerPayment({ commit, state }, paymentData) {
        try {
            commit("SET_PAYMENT_DATA", paymentData);
            if (paymentData && paymentData.method) commit("SET_METHOD", paymentData.method);

            let data = {
                paymentId: state.payment.payment_id || state.payment.paymentId,
                bucketCode: paymentData.external_reference || state.selectedPack.packCode,
                invoiceForm: { 
                    ...paymentData.form,
                    ...state.invoice,
                    document: paymentData.form?.document ?? paymentData.invoiceForm?.document,
                    item: state.selectedPack
                },
                method: state.method || state.payment.method,
                codeDiscount: state.codeDiscount,
            };

            // Se validan parametros faltantes en facturo, de lo contrario se realiza boleta
            if ((!data.invoiceForm.businessName || !data.invoiceForm.rut || 
                !data.invoiceForm.address || !data.invoiceForm.commune) && data.method !== "paypal") {
                data.invoiceForm.businessName = "";
                data.invoiceForm.rut = "";
                data.invoiceForm.address = "";
                data.invoiceForm.commune = "";
                data.invoiceForm.document = "receipt";
            }
            
            let registerResponse = await service.request("/accounts/payment/verify", data);
            commit("SET_COMPLETED_PAYMENT", registerResponse);
            return registerResponse;
        } catch (error) {
            console.error(error);
        }
    },
    async cachePayment({ commit, state }, paymentData) {
        try {
            let data = {
                externalReference: state.externalReference,
                bucketCode: state.selectedPack.packCode,
                invoiceForm: { 
                    ...paymentData.form,
                    ...state.invoice,
                    item: state.selectedPack
                },
                method: state.method || state.payment.method,
                codeDiscount: state.codeDiscount,
            };

            // Se validan parametros faltantes en facturo, de lo conrario se realiza boleta
            if ((!data.invoiceForm.businessName || !data.invoiceForm.rut || 
                !data.invoiceForm.address || !data.invoiceForm.commune) && data.method !== "paypal") {
                data.invoiceForm.businessName = "";
                data.invoiceForm.rut = "";
                data.invoiceForm.address = "";
                data.invoiceForm.commune = "";
                data.invoiceForm.document = "receipt";
            }
            
            let registerResponse = await service.request("/accounts/payment/cache", data);
            return registerResponse;
        } catch (error) {
            console.error(error);
        }
    },
    async validateDiscount({ commit }, { discountCode, packCode }) {
        try {
            let discount = await service.request("/accounts/discount", { 
                packCode: packCode.toUpperCase(),
                discountCode: discountCode.toUpperCase()
            });
            if (discount) {
                commit("SET_DISCOUNT", discountCode.toUpperCase());
            }
            return discount;
        } catch (error) {
            commit("SET_DISCOUNT", "");
            console.error(error);
        }
    },
};

export const getters = {
    invoicePath(state) {
        return state.completed ? state.completed.invoicePath : false;
    },
    paymentStatus(state) {
        return state.completed;
    },
};

export default {
    state,
    mutations,
    actions,
    getters
};
